import { Stack, Step, Stepper, Typography } from "@mui/material";
import type { Approval } from "../../../api/types/approvalTypes";
import ApprovalStepContent from "./ApprovalStepContent";
import ApprovalStepLabel from "./ApprovalStepLabel";

interface Props {
  approval: Approval;
}

const getActiveStepIndex = (approval: Approval) => {
  const index = approval.approvalStepStates.findIndex((a) => a.stepName === approval.currentApprovalStep);
  return index === -1 ? 0 : index;
};

const ApprovalDetailsStepsSection = ({ approval }: Props) => {
  const activeStepIndex = getActiveStepIndex(approval);

  const showAutoRejectInfo =
    approval.status === "Rejected" && approval.approvalStepStates.every((step) => step.status === "Skipped");

  return (
    <Stack spacing={2}>
      <Stack spacing={1}>
        <Typography variant="h6">Approval Steps</Typography>
        {showAutoRejectInfo && (
          <Typography color="textSecondary">
            This request was automatically rejected because it did not meet the conditions of any approval steps.
          </Typography>
        )}
      </Stack>
      <Stepper
        orientation="vertical"
        sx={{ "& .MuiStepConnector-root": { ml: 1.25 }, "& .MuiStepContent-root": { ml: 1.25, pl: 2 } }}
      >
        {approval.approvalStepStates.map((step, index) => {
          const notStarted = index > activeStepIndex && step.status === "Pending";
          return (
            <Step key={step.stepName} active>
              <ApprovalStepLabel step={step} notStarted={notStarted} />
              <ApprovalStepContent step={step} notStarted={notStarted} />
            </Step>
          );
        })}
      </Stepper>
    </Stack>
  );
};

export default ApprovalDetailsStepsSection;
